export const INVOICES_TOP_BAR_NEW_MANUAL_INVOICE_ID = 'invoicesTopBarNewManualInvoice';
